module.exports = __webpack_public_path__ + "img/title-bg.6d3d13b8.png";